module.exports = {
	"questions": {
		"result": -1,
		"qid": 0
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/app/state.json
// module id = 606
// module chunks = 0